<div class="mb-4 flex">
  <ng-content />
</div>
